import { render, staticRenderFns } from "./pizzaBuilder.vue?vue&type=template&id=4f08fd69&scoped=true&lang=pug"
import script from "./pizzaBuilder.vue?vue&type=script&lang=coffee"
export * from "./pizzaBuilder.vue?vue&type=script&lang=coffee"
import style0 from "./pizzaBuilder.vue?vue&type=style&index=0&id=4f08fd69&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f08fd69",
  null
  
)

export default component.exports